var React = require('react');

function CircleIconPlaySmallInline (props) {
    return React.createElement("svg",props,React.createElement("g",{"fillRule":"evenodd","transform":"translate(2 2)"},[React.createElement("rect",{"className":"circle","width":"24","height":"24","rx":"12","strokeWidth":"2","key":0}),React.createElement("path",{"className":"icon","strokeWidth":"0","d":"M15.212 11.477c.468.289.471.755 0 1.046l-4.306 2.66c-.468.289-.847.081-.847-.477V9.294c0-.552.375-.768.847-.477l4.306 2.66z","key":1})]));
}

CircleIconPlaySmallInline.defaultProps = {"viewBox":"0 0 28 28"};

module.exports = CircleIconPlaySmallInline;

CircleIconPlaySmallInline.default = CircleIconPlaySmallInline;
